import tw, { css, styled } from 'twin.macro';
import 'styled-components/macro';

interface LoadingProgressBarProps {
  value: number;
  className?: string;
  shine?: boolean;
}

const ProgressBar = styled.div(({ width }: { width: number }) => [
  tw`absolute top-[1px] right-0 h-1 bg-[#1C2230] transition-[width] duration-[1s]`,
  css`
    width: ${100 - width}%;
  `,
]);

const ProgressBarBg = styled.div(({ width, shine }: { width: number; shine: boolean }) => [
  tw`h-[10px] w-full relative`,
  tw`before:content-[''] before:absolute before:bottom-0 before:right-0 before:w-full before:h-1 before:blur`,
  shine &&
    tw`after:content-[''] after:absolute after:inset-0 after:opacity-0 after:bg-white after:animate-[shine_3s_ease-out_infinite]`,
  css`
    &,
    &:before {
      background: rgb(255, 143, 40);
      background: linear-gradient(
        90deg,
        rgba(255, 143, 40, 1) 0%,
        rgba(255, 80, 164, 1) 33%,
        rgba(121, 23, 182, 1) 66%,
        rgba(14, 113, 189, 1) 100%
      );
    }
    @keyframes shine {
      0% {
        opacity: 0;
        width: 0;
      }
      50% {
        opacity: 0.3;
      }
      100% {
        opacity: 0;
        width: ${width}%;
      }
    }
  `,
]);

export const LoadingProgressBar = ({ value, className = '', shine = false }: LoadingProgressBarProps) => {
  return (
    <div>
      <ProgressBarBg width={value} className={className} shine={shine}>
        <ProgressBar width={value} />
      </ProgressBarBg>
    </div>
  );
};
